import React from 'react';
import { useForm } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './Devices.scss';
import { FormHeading, FormInput } from 'components';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from '@cfa/react-components';
import { IDevice } from 'interfaces';

interface IDeviceModalProps {
    device: IDevice,
    show: boolean,
    onHide: () => void,
}

interface IDeviceForm extends IDevice {}

export function DeviceModal({ device, show, onHide }: IDeviceModalProps) {

    const form = useForm<IDeviceForm>({mode: 'onTouched'});

    return (
        <Modal show={show} onClose={onHide} scrollMode='modal-body' size={'lg'}>

            <ModalHeader>
                <FontAwesomeIcon icon="hdd" className="deviceModal_icon" />
                Device ID: {device.id}
            </ModalHeader>

            <ModalBody>
                <div className="deviceModal_body">
                    <div className="row">
                        <div className="col">
                            <FormHeading>Info</FormHeading>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <FormInput
                                form={form}
                                label="Manufacturer"
                                name="manufacturer"
                                defaultValue={device.manufacturer.name}
                                disabled={true}
                            />
                        </div>
                        <div className="col">
                            <FormInput
                                form={form}
                                label="Model Number"
                                name="modelNumber"
                                defaultValue={device.modelNumber}
                                disabled={true}
                            />
                        </div>
                        <div className="col">
                            <FormInput
                                form={form}
                                label="Serial Number"
                                name="serialNumber"
                                defaultValue={device.serialNumber}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col col-4">
                            <FormInput
                                form={form}
                                label="Location"
                                name="location"
                                defaultValue={device.location.number}
                                disabled={true}
                            />
                        </div>
                        <div className="col col-8">
                            <FormInput
                                form={form}
                                label="Thing ID"
                                name="thingID"
                                defaultValue={device.thingID}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <FormInput
                                form={form}
                                label="Mac Address"
                                name="macAddress"
                                defaultValue={device.macAddress}
                                disabled={true}
                            />
                        </div>
                        <div className="col">
                            <FormInput
                                form={form}
                                label="Service Now SysID"
                                name="sysID"
                                defaultValue={device.sysID}
                                disabled={true}
                            />
                        </div>
                        {device.correlationId && 
                            <div className="col">
                                <FormInput
                                    form={form}
                                    label="Correlation ID"
                                    name="correlationId"
                                    defaultValue={device.correlationId}
                                    disabled={true}
                                />
                            </div>
                        }
                    </div>
                    <div className="row">
                        <div className="col">
                            <FormInput
                                form={form}
                                label="Last Seen"
                                name="lastSeen"
                                defaultValue={device.lastSeen.toString()}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <FormHeading>Firmware</FormHeading>
                        </div>
                    </div>
                    <div className="row">
                        {device.firmware && Object.keys(device.firmware).map(k => (
                            <div key={k} className="col">
                                <FormInput
                                    form={form}
                                    label={k}
                                    name="firmware"
                                    defaultValue={device.firmware[k]}
                                    disabled={true}
                                />
                            </div>
                        ))}
                    </div>
                    <div className="row">
                        <div className="col">
                            <FormHeading>Menu</FormHeading>
                        </div>
                    </div>
                    <div className="row">
                        {device.menu && Object.keys(device.menu).map(k => (
                            <div key={k} className="col">
                                <FormInput
                                    form={form}
                                    label={k}
                                    name="menu"
                                    defaultValue={device.menu[k]}
                                    disabled={true}
                                />
                            </div>
                        ))}
                    </div>
                    <div className="row">
                        <div className="col">
                            <FormHeading>Update Status</FormHeading>
                        </div>
                    </div>
                    <div className="row">
                        {device.updateStatus && Object.keys(device.updateStatus).map(k => (
                            <div key={k} className="col">
                                <FormInput
                                    form={form}
                                    label={k}
                                    name="updateStatus"
                                    defaultValue={device.updateStatus[k].status + " - " + device.updateStatus[k].version}
                                    disabled={true}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </ModalBody>

            <ModalFooter>
                <Button onClick={onHide}>
                    Close
                </Button>
            </ModalFooter>

        </Modal>
    );
}